import { render, staticRenderFns } from "./SSearchStaffMutiNew.vue?vue&type=template&id=210d954d&"
import script from "./SSearchStaffMutiNew.vue?vue&type=script&lang=js&"
export * from "./SSearchStaffMutiNew.vue?vue&type=script&lang=js&"
import style0 from "./SSearchStaffMutiNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SSearchStaffMutiNew.vue?vue&type=custom&index=0&blockType=s-search-staff-muti&v-model=euids&showSupportStaff=true&showGroup=true&%40dataChange=staffObjArray%20%3D%20%24event&label=%E4%B8%BB%E7%AE%A1"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VChip,VListItemContent,VListItemSubtitle,VListItemTitle})
